export default "__VITE_ASSET__CnI507wt__"